import { render, staticRenderFns } from "./ProductsService.vue?vue&type=template&id=3d99dcc8&scoped=true&"
import script from "./ProductsService.vue?vue&type=script&lang=js&"
export * from "./ProductsService.vue?vue&type=script&lang=js&"
import style0 from "./ProductsService.vue?vue&type=style&index=0&id=3d99dcc8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d99dcc8",
  null
  
)

export default component.exports